module.exports = __webpack_public_path__ + "static/media/ai1.50b91192.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/ai1.jpg
// module id = 52
// module chunks = 0